import React, { useEffect, useState } from "react";
import "react-sliding-pane/dist/react-sliding-pane.css";
import "jspdf-autotable";

import AllContractReport from "./AllContractReport";
import ActiveContractReport from "./ActiveContratReport";
import PendingContractsReport from "./ContractByStatus";
import OriginalContractTermReport from "./OrignalTermContract";
import RemainingContractTermReport from "./RemainingTermReport";

function ContractReport({ id, setContract }) {
	const [items, setItems] = useState([]);
	const [loading, setLoading] = useState(true);
	const [viewcontract, setViewContract] = useState("");
	const [contracts, setContracts] = useState(false);
	const [activecontract, setActiveContract] = useState(false);
	const [pendingcontract, setPendingContract] = useState(false);
	const [contractoriginalterm, setContractOriginalTerm] = useState(false);
	const [contractremainingterm, setContractRemainingTerm] = useState(false);

	useEffect(() => {
		setLoading(false);
	}, []);

	useEffect(() => {
		setViewContract(setContract);
	}, [id, setContract]);

	useEffect(() => {
		viewcontract === "contracts" ? setContracts(true) : setContracts(false);
		viewcontract === "ActiveContract"
			? setActiveContract(true)
			: setActiveContract(false);
		viewcontract === "ContractsByStatus"
			? setPendingContract(true)
			: setPendingContract(false);
		viewcontract === "Contractsoriginalterm"
			? setContractOriginalTerm(true)
			: setContractOriginalTerm(false);
		viewcontract === "Contractsremainingterm"
			? setContractRemainingTerm(true)
			: setContractRemainingTerm(false);
	}, [viewcontract]);

	return (
		<>
			<div className="content container-fluid">
				<div value={viewcontract} className="pt-1">
				</div>
				<div className="body py-2">
					<div className="col-md-12">
						{contracts && <AllContractReport />}
						{activecontract && <ActiveContractReport id={items} />}
						{pendingcontract && <PendingContractsReport />}
						{contractoriginalterm && <OriginalContractTermReport />}
						{contractremainingterm && <RemainingContractTermReport />}
					</div>
				</div>
			</div>
		</>
	);
}

export default ContractReport;
